import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

/**
 * Shared look for a linked grid cell: inherits the row's type, underlines and
 * takes the accent only on hover. Matches the card's inline links, so the same
 * value reads the same way in either view.
 */
export const linkCellStyle = css`
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${colors.PRIMARY};
    text-decoration: underline;
  }
`
